import styled from 'styled-components'
import { maxWidth, space, textAlign, themeGet } from 'styled-system'
import { rem } from 'polished'

import { SearchIcon } from 'components/Icons'
import { fadeInAnimation } from 'styles/animation'
import theme from 'styles/theme'
import Button from 'components/Button'
import { getBGColor } from 'utils/themeUtils'

export const SearchButton = styled(Button)`
  width: 100%;
  padding: ${theme.space[2]} ${theme.space[2]};
  ${theme.mediaQueries.medium} {
    max-width: 250px;
    width: 100%;
  }
`

export const SearchButtonIcon = styled(SearchIcon)`
  display: flex;
  align-items: center;

  margin-left: 10px;

  html[dir='rtl'] & {
    margin-right: 10px;
  }

  svg g {
    stroke: currentColor;
  }
`

export const Section = styled.section`
  animation: ${fadeInAnimation} .2s ease-in-out;
  ${maxWidth}
  ${space}
  ${textAlign}

  button {
    vertical-align: middle;
  }
`

export const Select = styled.div`
  display: inline-block;
  position: relative;
  margin-top: ${theme.space[3]};
  vertical-align: middle;
  width: 100%;

  ${theme.mediaQueries.medium} {
    max-width: 250px;
    width: 250px;
    margin-top: 0;
    margin-right: 0;
    margin-left: ${theme.space[3]};
  }

  html[dir='rtl'] & {
    ${theme.mediaQueries.small} {
      margin-left: 0;
      margin-right: ${theme.space[3]};
    }
  }

  select::-ms-expand {
    display: none;
  }

  select {
    display: inline-block;
    padding: ${theme.space[2]} calc(${theme.space[2]} + 15px) ${theme.space[2]}
      ${theme.space[2]};

    html[dir='rtl'] & {
      padding: ${theme.space[2]} ${theme.space[2]} ${theme.space[2]}
        calc(${theme.space[2]} + 15px);
    }
    option {
      background: ${getBGColor()};
    }
    min-height: 48px;
    background: none;
    border: 1px solid ${themeGet('colors.sagedark')};
    border-radius: 0;
    box-shadow: none;
    font-size: ${rem(12)};
    line-height: 1.8;
    text-transform: uppercase;
    outline: none;
    -webkit-appearance: none;

    ${(props) => props.fixedSize && `height: 60px;`}

    width: 100%;
    ${theme.mediaQueries.medium} {
      max-width: 250px;
      width: 100%;
    }
  }

  ${(props) => props.fixedSize && `span { top: 22px; }`}

  &, select, span {
    color: ${themeGet('colors.sagedark')};
  }
`

export const SelectIcon = styled.span`
  position: absolute;
  top: 15px;
  right: 15px;
  transform: rotate(-90deg);
  color: inherit;

  html[dir='rtl'] & {
    right: auto;
    left: 15px;
  }

  span,
  svg,
  path {
    color: inherit;
    fill: currentColor;
  }
`

export const ResultCountWrapper = styled.div`
  div {
    display: inline-block;
  }
`

export const ResultCount = styled.span`
  color: ${(props) => props.theme.colors.sagemediumToBlack};
  margin-left: 10px;
  text-transform: uppercase;

  &::before {
    background: currentColor;
    content: '';
    display: inline-block;
    height: 3px;
    margin-right: 8px;
    transform: translateY(-3px) rotate(45deg);
    width: 3px;
  }

  html[dir='rtl'] & {
    margin-left: 0px;
    margin-right: 10px;

    &::before {
      margin-right: 0px;
      margin-left: 8px;
    }
  }
`
